export default __webpack_public_path__ + "static/media/ocs-group.66b9c1d0.png";